import {Ability} from '../../../../generated/types';

export const ABILITIES: Ability[] = [
	Ability.Strength,
	Ability.Dexterity,
	Ability.Constitution,
	Ability.Intelligence,
	Ability.Wisdom,
	Ability.Charisma,
];

export const ABILITY_BY_SHORT_NAME: Record<string, Ability> = {
	Str: Ability.Strength,
	Dex: Ability.Dexterity,
	Con: Ability.Constitution,
	Int: Ability.Intelligence,
	Wis: Ability.Wisdom,
	Cha: Ability.Charisma,
};

export const SKILL_ABILITY: Record<string, Ability> = {
	Athletics: Ability.Strength,
	Acrobatics: Ability.Dexterity,
	SleightOfHand: Ability.Dexterity,
	Stealth: Ability.Dexterity,
	Arcana: Ability.Intelligence,
	History: Ability.Intelligence,
	Investigation: Ability.Intelligence,
	Nature: Ability.Intelligence,
	Religion: Ability.Intelligence,
	AnimalHandling: Ability.Wisdom,
	Insight: Ability.Wisdom,
	Medicine: Ability.Wisdom,
	Perception: Ability.Wisdom,
	Survival: Ability.Wisdom,
	Deception: Ability.Charisma,
	Intimidation: Ability.Charisma,
	Performance: Ability.Charisma,
	Persuasion: Ability.Charisma,
};

export const SKILLS = Object.keys(SKILL_ABILITY);

export const DEFAULT_ABILITY_SCORE = 10;
export const DEFAULT_ABILITY_CAP = 20;

export const isAbility = (value: unknown): value is Ability => ABILITIES.includes(value as Ability);

export const abilityModifier = (score: number) => Math.floor((score - 10) / 2);

export const proficiencyBonusForLevel = (level: number) => 2 + Math.floor((Math.max(1, level) - 1) / 4);
